var LocalStorage = function () { // eslint-disable-line no-unused-vars
    'use strict';

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */

    let storageIsSupported = checkLocalStorageIsSupported();

    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */

    function checkLocalStorageIsSupported() {
        const test = 'testlocalstorage';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (error) {
            return false;
        }
    }

    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */

    return {
        /**
         * Set a key value pair to local storage.
         * @param {string} key
         * @param {string} value
         */
        set: function (key, value) {
            if (storageIsSupported) {
                localStorage.setItem(key, value);
            }
        },

        /**
         * Get a value from local storage using a specified key.
         * @param {string} key
         * @returns {string|null}
         */
        get: function (key) {
            return storageIsSupported ? localStorage.getItem(key) : null;
        },

        /**
         * Remove a value from local storage using a specified key.
         * @param {string} key
         */
        remove: function (key) {
            if (storageIsSupported) {
                localStorage.removeItem(key);
            }
        }
    };
}();